import { CoachLeadsCourseDTO } from "./CoachLeadsCourseDTO";
import { MemberInCourseDTO } from "./MemberInCourseDTO";
import { TimeSlotDTO } from "./TimeSlotDTO";
import { TrainingSchedule, trainingScheduleInit } from "./TrainingSchedule";

export interface Course {
  id: number | null;
  name: string;
  competitive: boolean;
  fee: number;
  capacity: number;
  color: string;
  description: string;
  trainingSchedule: TrainingSchedule;
  timeSlots: TimeSlotDTO[];
  coachLeadsCourses: CoachLeadsCourseDTO[];
  memberInCourses: MemberInCourseDTO[];
}

export const courseInit: Course = {
  id: null,
  name: "",
  competitive: false,
  fee: 0,
  capacity: 0,
  color: "#fff000",
  description: "",
  trainingSchedule: trainingScheduleInit,
  timeSlots: [],
  coachLeadsCourses: [],
  memberInCourses: [],
}
